import React from "react";
import { ListItemIcon, Menu, MenuItem } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";

export default function FeatureSettingsActions({ isDefault, onCopy, onPaste, copyDisabled, pasteDisabled, copiedSource }) {
  const [anchor, setAnchor] = React.useState(null);
  const menuId = React.useId();
  const runAction = (action) => {
    setAnchor(null);
    action();
  };

  return <>
    <button type="button" aria-label={isDefault ? "Default actions" : "Location actions"} title={isDefault ? "Default actions" : "Location actions"} aria-haspopup="menu" aria-expanded={Boolean(anchor)} aria-controls={anchor ? menuId : undefined}
      onClick={(event) => setAnchor(event.currentTarget)}
      className="inline-flex shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-white w-9 h-9 text-xs font-medium text-slate-600 hover:bg-slate-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-600">
      <MoreHorizIcon fontSize="small" />
    </button>
    <Menu id={menuId} anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }} transformOrigin={{ vertical: "top", horizontal: "right" }}
      MenuListProps={{ "aria-label": isDefault ? "Default actions" : "Location actions" }}
      PaperProps={{ sx: { mt: 0.5, border: "1px solid #e2e8f0", borderRadius: "8px", maxWidth: "calc(100vw - 32px)",
        boxShadow: "0 8px 24px rgba(15, 23, 42, 0.12)", color: "#334155",
        "& .MuiMenuItem-root": { fontSize: 14, py: 1, whiteSpace: "normal", "&:hover, &.Mui-focusVisible": { bgcolor: "#f5f3ff", color: "#6d28d9" } },
        "& .MuiListItemIcon-root": { color: "inherit" } } }}>
      <MenuItem disabled={copyDisabled} onClick={() => runAction(onCopy)}>
        <ListItemIcon><ContentCopyIcon fontSize="small" /></ListItemIcon>Copy all feature switches
      </MenuItem>
      <MenuItem disabled={pasteDisabled} onClick={() => runAction(onPaste)}>
        <ListItemIcon><ContentPasteIcon fontSize="small" /></ListItemIcon>
        <div>Paste feature switches<p className="mt-0.5 text-xs text-slate-500">{copiedSource ? `From ${copiedSource}` : "Copy from a location or defaults first"}</p></div>
      </MenuItem>
    </Menu>
  </>;
}
